import { format, SIMPLE_DATE_FORMAT, DATEPICKER_FORMAT, parse } from '../../common/dates';

export const datesToInputs = ({ checkIn, checkOut }, { checkInInput, checkOutInput }) => {
  const checkInString = checkIn ? format(checkIn, SIMPLE_DATE_FORMAT) : '';
  const checkOutString = checkOut ? format(checkOut, SIMPLE_DATE_FORMAT) : '';

  checkInInput.value = checkInString;
  checkOutInput.value = checkOutString;
};

export function setDates(date1, date2) {
  const datePickStartEl = document.querySelector('.datepick-start');
  const datePickEndEl = document.querySelector('.datepick-end');
  datePickStartEl.value = format(date1, DATEPICKER_FORMAT).toString();
  datePickEndEl.value = format(date2, DATEPICKER_FORMAT).toString();
}

export const inputsToCalendar = ({ checkInInput, checkOutInput }) => {
  const checkIn = checkInInput.value ? parse(checkInInput.value, SIMPLE_DATE_FORMAT) : null;
  const checkOut = checkOutInput.value ? parse(checkOutInput.value, SIMPLE_DATE_FORMAT) : null;

  return {
    checkIn, checkOut
  };
};
